import { Component, OnInit, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ValidationConsts } from '@app/shared/common/validation-consts';
import { LocalizeService } from '@services/helpers/localize/localize.service';


@Component({
    selector: 'app-control-error',
    templateUrl: './control-error.component.html',
    styleUrls: ['./control-error.component.scss'],
    standalone: true,
    imports: []
})
export class ControlErrorComponent implements OnInit {

  private validatorMap = ValidationConsts.VALIDATION_MESSAGES;
  public validationMessages: string[] = [];

  @Input() set errors(content: ValidationErrors) {
    this.validationMessages = [];
    for (const error of Object.keys(content)) {
      this.validationMessages.push(this.localize.l(this.validatorMap[error]?.(content.error) ?? this.validatorMap.default()));
    }
  }

  constructor(private localize: LocalizeService) { }

  ngOnInit(): void {
  }

}
